import React from "react";
import { createStyles } from "@mantine/emotion";
import AppLayout from "../../Components/Styles/AppLayout";
import ContentLayout from "../../Components/Styles/ContentLayout";
import Header from "../../Components/Common/Header";

const useStyles = createStyles(() => ({
  outerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 1rem",
  },
}));

const ErrorPage = ({ language, config }) => {
  const { classes } = useStyles();

  return (
    <AppLayout pageName="error">
      <Header hideUser={true} config={config} language={language} />
      <ContentLayout>
        <main className={classes.outerWrapper} id="main-page-content">
          <h1>Sidan hittades inte</h1>
          <p>Kontrollera länken och försök igen</p>
          <p>Om problemet kvarstår, vänligen kontakta kundtjänst</p>
        </main>
      </ContentLayout>
    </AppLayout>
  );
};

export default ErrorPage;
